import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Box, Button, CircularProgress } from "@mui/material";

type Props = {
  canCreate: boolean;
  canManageFolder: boolean;
  disabled?: boolean;
  isLoadingDeletePreview?: boolean;
  onCreateFolder: () => void;
  onRenameFolder: () => void;
  onDeleteFolder: () => void;
};

export function FolderToolbar({
  canCreate,
  canManageFolder,
  disabled = false,
  isLoadingDeletePreview = false,
  onCreateFolder,
  onRenameFolder,
  onDeleteFolder,
}: Props) {
  if (!canCreate && !canManageFolder) return null;

  return (
    <Box display="flex" alignItems="center" gap={1} flexShrink={0}>
      {canCreate && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<CreateNewFolderOutlinedIcon />}
          onClick={onCreateFolder}
          disabled={disabled}
          sx={{ textTransform: "none", bgcolor: "#FFFFFF" }}
        >
          Nova pasta
        </Button>
      )}
      {canManageFolder && (
        <>
          <Button
            size="small"
            variant="outlined"
            startIcon={<DriveFileRenameOutlineIcon />}
            onClick={onRenameFolder}
            disabled={disabled}
            sx={{ textTransform: "none", bgcolor: "#FFFFFF" }}
          >
            Renomear pasta
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            startIcon={
              isLoadingDeletePreview ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <DeleteOutlineIcon />
              )
            }
            onClick={onDeleteFolder}
            disabled={disabled || isLoadingDeletePreview}
            sx={{ textTransform: "none", bgcolor: "#FFFFFF" }}
          >
            Excluir pasta
          </Button>
        </>
      )}
    </Box>
  );
}
